import React from "react";

const SubtleBackground = ({
  children,
  bgColor = "#FB923C",
  isCardCover = false,
}) => {
  // Alpha-Wert für ca. 20 % Opazität
  const bgAlpha = "33";

  const style = {
    backgroundColor: `${bgColor}${bgAlpha}`,
  };

  return (
    <div
      className={`relative ${
        !isCardCover ? "min-h-screen" : "h-20"
      } w-full flex items-center justify-center`}
      style={style}
    >
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default SubtleBackground;
